import { NavLink, Outlet } from "react-router-dom";
import { logout } from "../utils/auth";
import "./admin.css";

export default function AdminLayout() {
  return (
    <div className="admin-shell">
      <aside className="sidebar">
        <div className="brand">
          <img
            src="/images/logo.png"
            alt="Oz Vehadar Logo"
            className="brand-logo"
          />
          <span className="brand-title">Oz Vehadar</span>
        </div>

        <nav className="nav">
          <NavLink to="/" end className="nav-link">
            Dashboard
          </NavLink>
          <NavLink to="/users" className="nav-link">
            Users
          </NavLink>
           <NavLink to="/subjects" className="nav-link">
            Story Subjects
          </NavLink>
          <NavLink to="/subscriptions" className="nav-link">
  Subscriptions
</NavLink>
<NavLink to="/user-subscriptions" className="nav-link">
  Users Subscriptions
</NavLink>
        </nav>

        <button className="logout" onClick={logout}>
          Logout
        </button>
      </aside>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
